import { useEffect, useState } from "react";

import cx from "classnames";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../../contexts/toastr.context";
import mainTextLogo from "../../_assets/vectors/main-text-logo.svg";
import { createUserWallPageRoute } from "../../_pages/user-wall.page";
import { CommunityService } from "../../_service";
import { setCommunity } from "../../_store/_actions/community.actions";
import { Avatar } from "../avatar.component";
import CommunityLogo from "../community/community-logo.component";
import { NotificationQuickView } from "../notification-quick-view.component";

import { useAppService } from "../../hooks/use-app-service";
import { history } from "../../_config";
import { redirectToAuthUrl } from "../../_config/helper.config";
import { mixPanel } from "../../_config/mixpanel.config";
import { COMMUNITY_HOMEPAGE_ROUTE } from "../../_pages/community-home/community-home.page";
import { COMMUNITY_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/community-general-settings.page";
import { USER_PROFILE_UPDATE_PAGE_ROUTE } from "../../_pages/community-settings/profile-update.page";
import { store } from "../../_store";
import { getKarmaPointsAction } from "../../_store/community-karma-points.store/karma-points.action";
import MainUtil from "../../_utils/main.util";
import I18 from "../atoms/i18";
import { Button } from "../button.component";
import IconButton2 from "../icon-button-2-component";
import UIcon from "../uicon-component";
import AnalyticsLinkIcon from "./analytics-link-icon";
import CommunityNavLinks from "./community-navlinks";
import CommunitySettingIcon from "./community-setting-icon";
import DirectMessageIcon from "./direct-message-icon";
import HelpScoutIcon from "./help-scout-button";
import KarmaPointsHeaderButton from "./karma-points-button";
import SearchCommunityIcon from "./search-community-icon";
import { SubscribersCountView } from "./subscribers-buttton";

function HeaderComponent({
  action,
  user,
  community,
  updateCommunity,
  addToast,
  web3Logout,
  isSidebarOpen,
  setIsSidebarOpen,
}) {
  const { analyticsService } = useAppService();

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // hide on clicking outside this
  useEffect(() => {
    if (!isDropdownVisible) {
      return;
    }

    const closeMenuListener = (e) => {
      setIsDropdownVisible(false);
    };

    window.document.body.addEventListener("click", closeMenuListener);

    return () => {
      window.document.body.removeEventListener("click", closeMenuListener);
    };
  }, [isDropdownVisible]);

  const userId = user?.id;
  const communityId = community?.id;

  useEffect(() => {
    if (communityId && userId) {
      // get community karma points
      store.dispatch(getKarmaPointsAction());
    }
  }, [communityId, userId]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 640); // Updates the isMobile state based on screen width
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onLogout = async () => {
    await MainUtil.logout(community, web3Logout);
  };

  return (
    <div className="Header border-b theme-border-default theme-bg-surface">
      <div className="header-container px-3 sm:px-0 mg:px-6 xl:px-0 py-0.5">
        <div className="flex items-center">
          <div
            onClick={(e) => {
              setIsSidebarOpen(!isSidebarOpen);
            }}
            className="mobile-header-hamburger select-none">
            <UIcon icon={isSidebarOpen ? "cross" : "menu-burger"} size="lg" />
          </div>
          {/* Main logo */}
          <Link
            to={COMMUNITY_HOMEPAGE_ROUTE}
            className="MainLogo flex items-center">
            {!community?.configuration?.hideHeaderCommunityLogo ? (
              <CommunityLogo community={community} height={42} />
            ) : null}
            <div className="hidden sm:flex px-4 py-1 text-lg theme-text-heading-1 font-semibold">
              {community ? (
                !community?.configuration?.hideHeaderCommunityName ? (
                  <div className="">
                    {community.name.length > 20
                      ? community.name.substring(0, 20) + "..."
                      : community.name}
                  </div>
                ) : null
              ) : (
                <img
                  src={mainTextLogo}
                  className={"rounded flex-shrink-0 "}
                  onError={(e) => {
                    // setImageHasError(true);
                  }}
                  alt=""
                />
              )}
            </div>
          </Link>
        </div>
        {/* Search bar */}
        {/* {community && user ? <HeaderTagSearchbar user={user} /> : <></>} */}

        {/* Nav links */}
        {community?.configuration?.showCommunityLinksInHeader ? (
          <CommunityNavLinks />
        ) : (
          <></>
        )}

        {/* Options */}
        <div className="OtherOptions flex items-center place-content-end">
          {user ? (
            <>
              <SearchCommunityIcon />

              {!isMobile && (
                <>
                  <CommunityJoinButton
                    action={action}
                    user={user}
                    community={community}
                    updateCommunity={updateCommunity}
                    addToast={addToast}
                  />
                  {/* Karma points button */}
                  <KarmaPointsHeaderButton />
                  {/* subscribers count button */}
                  <SubscribersCountView />
                  {/* direct message button */}
                  <DirectMessageIcon />
                  {/* notification button */}
                  {community && user && <NotificationQuickView />}
                  {/* Community setting button */}
                  {community && user && <CommunitySettingIcon />}
                  {/* community join button */}

                  {community && !community.configuration.isWhiteLabel && (
                    <>
                      {/* analytics icon */}
                      <AnalyticsLinkIcon />
                      {/* for admin, help */}
                      <HelpScoutIcon />
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <></>
          )}

          {/* other user details */}
          {!community?.disableHeaderDropdown || true ? (
            user ? (
              <div
                className={cx(
                  "HeaderUserDropDownHolder relative flex items-center",
                  {
                    "sm:block hidden": Boolean(
                      community?.configuration?.disableMobileViewHeaderDropdown
                    ),
                  },
                  {
                    "sm:hidden hidden": Boolean(
                      community?.configuration?.disableHeaderDropdown
                    ),
                  }
                )}>
                <Avatar
                  user={user}
                  hideNameOnMobile
                  noName
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsDropdownVisible(!isDropdownVisible);
                  }}
                  className="rounded-lg hover:shadow-lg p-2 pr-3 cursor-pointer"
                />
                <div
                  className={cx(
                    "dropdown shadow-lg theme-bg-surface border theme-border-default  rounded sm:w-40  w-[200px]",
                    {
                      visible: isDropdownVisible,
                      hidden: !isDropdownVisible,
                    }
                  )}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}>
                  {/* show user name */}
                  {isMobile && (
                    <>
                      {/* Karma points button */}
                      <div className="flex justify-center mt-1 relative z-40">
                        <KarmaPointsHeaderButton />
                      </div>
                    </>
                  )}
                  {user.userId ? (
                    <div className="px-4 py-1 theme-text-subtitle-1 cursor-default">
                      @{user.userId}
                    </div>
                  ) : (
                    <></>
                  )}
                  {/* show edit community button to creator */}

                  {isMobile && (
                    <div>
                      <div
                        onClick={() => {
                          history.push("/direct-message/users");
                          mixPanel.track("direct-message", {
                            CTAButton: "Header",
                          });
                        }}
                        className="cursor-pointer theme-text-default  hover:bg-[#aaa2] px-1 rounded-md block">
                        <DirectMessageIcon />
                      </div>
                      <div className="theme-text-default  hover:bg-[#aaa2] block rounded-md cursor-pointer px-1">
                        {community && user && <NotificationQuickView />}
                      </div>
                    </div>
                  )}
                  {community && community.myRole === "admin" ? (
                    <>
                      {isMobile && (
                        <div className="flex flex-col px-1">
                          <CommunityJoinButton
                            action={action}
                            user={user}
                            community={community}
                            updateCommunity={updateCommunity}
                            addToast={addToast}
                          />

                          {/* subscribers count button */}
                          <div
                            onClick={() => {
                              history.push("/settings/members");
                            }}
                            className="cursor-pointer theme-text-default  hover:bg-[#aaa2] px-1 rounded-md flex flex-row items-center">
                            <IconButton2 icon="address-book" />
                            <I18>Community member</I18>
                          </div>

                          {!community.configuration.isWhiteLabel && (
                            <>
                              <div className="cursor-pointer theme-text-default hover:bg-[#aaa2] px-1 rounded-md flex flex-row items-center">
                                {/* analytics icon */}
                                <AnalyticsLinkIcon />
                              </div>
                              {/* for admin, help */}
                              <div
                                onClick={() => {
                                  window.Beacon && window.Beacon("open");
                                }}
                                className="cursor-pointer theme-text-default hover:bg-[#aaa2] px-1 rounded-md flex flex-row items-center">
                                <HelpScoutIcon community={community} />
                                <I18>Help</I18>
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <></>
                  )}

                  {/* my profile button */}
                  {community && (
                    <Link
                      to={createUserWallPageRoute(user.id, "activity")}
                      onClick={(e) => {
                        setIsDropdownVisible(false);
                        analyticsService.track("landing-on-profile")
                      }}
                      className="theme-text-default block hover:bg-[#aaa2] px-1 rounded-md">
                      <div className="flex flex-row items-center">
                        <IconButton2 icon="user" />
                        <I18>My Profile</I18>
                      </div>
                    </Link>
                  )}
                  {/* show community settings button */}
                  <div className=" cursor-pointer ">
                    <Link
                      to={
                        community?.myRole === "admin"
                          ? COMMUNITY_UPDATE_PAGE_ROUTE
                          : USER_PROFILE_UPDATE_PAGE_ROUTE
                      }
                      onClick={(e) => {
                        setIsDropdownVisible(false);
                      }}
                      className="theme-text-default block hover:bg-[#aaa2] m-1 rounded-md">
                      <div className="flex flex-row items-center">
                        <IconButton2 icon="settings" />
                        <I18>Settings</I18>
                      </div>
                    </Link>
                  </div>

                  {/* logout button */}
                  {community?.disableHeaderDropdown ? (
                    <></>
                  ) : (
                    <div
                      onClick={onLogout}
                      className="cursor-pointer theme-text-default block hover:bg-[#aaa2] m-1 rounded-md">
                      <div className="flex flex-row items-center theme-text-danger">
                        <IconButton2 icon="sign-out" />
                        <I18>Logout</I18>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="flex items-center w-full place-content-between">
                <div className="w-1" />
                <Button
                  label="Login"
                  onClick={(e) => {
                    redirectToAuthUrl(community);
                  }}
                />
              </div>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
}

/**
 * Component to show community join button
 * @param {*} param0
 * @returns
 */
function CommunityJoinButton({
  user,
  action,
  community,
  updateCommunity,
  addToast,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const communityId = community?.id;
  const userId = user?.id;
  const { analyticsService } = useAppService();

  // load the community join status
  useEffect(() => {
    if (community && !("joined" in community) && user) {
      setIsLoading(true);
      CommunityService.getCommunityById(user, communityId)
        .then(({ community }) => {
          // if we want to auto sub and user is not already subbed
          if (action === "autosub" || !community.joined) {
            // subscribe to community
            CommunityService.joinCommunity(user, community.id)
              .then(({ community }) => {
                setIsLoading(false);
                analyticsService.track("subscribe-community", {
                  communityPlan: community.plan ? community.plan.planType : "free"
                });

                // update community
                updateCommunity(community);
                // show message
                addToast("Subscribed to" + " " + community.name);
              })
              .catch((error) => {
                setIsLoading(false);
                console.log({
                  error,
                  message: "Subscribe to community failed!",
                });
                addToast(
                  "Could not subscribe to" + " " + community.name,
                  "",
                  ToastTypes.danger
                );
              });
          } else {
            // just update the community
            setIsLoading(false);
            updateCommunity(community);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log({ error, message: "Loading community by id failed!" });
          addToast(
            "Could not load community by id " + community.name,
            "",
            ToastTypes.danger
          );
        });
    }
  }, [communityId, userId, action]); // no need to add addToast, community and setCommunity as it will break the code

  // if (isLoading)
  // return <div className="h-6 w-6 animate-pulse bg-gray-300 rounded-full"></div>
  return <></>;

  return user && community && !community.joined ? (
    <div
      className="px-4 py-2 rounded theme-bg-primary font-semibold mr-4 text-white cursor-pointer"
      onClick={(e) => {
        // subscribe to community
        CommunityService.joinCommunity(user, community.id)
          .then(({ community }) => {
            // update community
            updateCommunity(community);
            // show message
            addToast("Subscribed to " + community.name);
          })
          .catch((error) => {
            console.log({ error, message: "Subscribe to community failed!" });
            addToast(
              "Could not subscribe to " + community.name,
              "",
              ToastTypes.danger
            );
          });
      }}>
      Subscribe
    </div>
  ) : (
    <></>
  );
}

const Header = 
  withToast(
    connect(
      (s) => ({
        user: s.auth,
        community: s.community,
      }),
      (d) =>
        bindActionCreators(
          {
            updateCommunity: setCommunity,
          },
          d
        )
    )(HeaderComponent)
  )
;

export default Header;
